module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("John Somerset is the best-selling author of "), _c('em', [_vm._v("Lasseter’s Truth")]), _vm._v(" and "), _c('em', [_vm._v("The Excalibur File")]), _vm._v(". He was born in Melbourne, Australia and educated at Geelong Grammar and Melbourne University.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("He spent his working life in international marketing and latterly advertising, is a winner of the Hoover Award for Marketing, Australia’s premier marketing award of its time and is a qualified PADI scuba diver.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("He lives and writes at Anglesea, Victoria with his wife and one-eyed kelpie.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0